<template>
  <search-body />
</template>

<script>
import AgeTechService from "@/components/ageTechService/AgeTechService.vue";

export default {
  name: "AgeTechService",
  components: {
    "search-body": AgeTechService,
  },
};
</script>
